import { AuthClient, removeKeyFromUrl } from '@skytech/auth'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import authResources from '@/resources/auth'

const useLogIn = (config?: { isUrlCredentials?: boolean }) => {
  const navigate = useNavigate()

  const loginMutation = useMutation(
    (args: {
      phoneNumber: string
      phoneCountryId: number
      password?: string
      accessCode?: string
    }) => authResources.logIn(args),
    {
      onSuccess({ token }) {
        AuthClient.setToken(token)

        if (config?.isUrlCredentials) removeKeyFromUrl(navigate)
      },
      onError() {
        // We don't want to redirect from the login page when logging with credentials
        if (config?.isUrlCredentials) AuthClient.logOut({ isTriggeredProgrammatically: true })
      },
    }
  )

  return loginMutation
}

export default useLogIn
